import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { CommonTranslationModule, CommonUIElementsModule } from '@sdbn/common';
import { VisitorLeaveFailedComponent } from './component/visitor-leave-failed.component';



@NgModule({
  declarations: [
    VisitorLeaveFailedComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    DictionaryModule,
    CommonTranslationModule,
    CommonUIElementsModule
  ]
})
export class VisitorLeaveFailedModule { }
